import VueRouter from "vue-router";
import RouterView from "@/views/RouterView.vue";
//防止路由重复报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: "hash",
    // mode: "history",
    routes: [
        {
            path: "/",
            component: RouterView,
            children: [
                {
                    path: "/activity",
                    component: () => import("@/views/activity/Main.vue"),
                    redirect: "/activity/management",
                    children: [
                        {
                            path: "/activity/management",
                            component: () => import("@/views/activity/activityManagement/ActivityManagement.vue"),
                            meta: {
                                title: "活动管理",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/management",
                                id: 1
                            }
                        },
                        {
                            path: "/activity/managementEdit",
                            component: () => import("@/views/activity/activityManagement/ActivityManagementEdit.vue"),
                            meta: {
                                title: "新建活动",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/management",
                                id: 1
                            }
                        },
                        {
                            path: "/activity/managementDetails",
                            component: () => import("@/views/activity/activityManagement/ActivityManagementDetails.vue"),
                            meta: {
                                title: "活动详情",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/management",
                                id: 1
                            }
                        },
                        {
                            path: "/activity/managementInfo",
                            component: () => import("@/views/activity/activityManagement/ActivityManagementInfo.vue"),
                            meta: {
                                title: "编辑信息",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/management",
                                id: 1
                            }
                        },
                        {
                            path: "/activity/addClass",
                            component: () => import("@/views/activity/activityManagement/AddClass.vue"),
                            meta: {
                                title: "新建班级",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/management",
                                id: 1
                            }
                        },
                        {
                            path: "/activity/classDetails",
                            component: () => import("@/views/activity/activityManagement/classDetails.vue"),
                            meta: {
                                title: "班级详情",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/management",
                                id: 1
                            }
                        },
                        {
                            path: "/activity/classEdit",
                            component: () => import("@/views/activity/activityManagement/classEdit.vue"),
                            meta: {
                                title: "编辑课程",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/management",
                                id: 1
                            }
                        },
                        {
                            path: "/activity/tasks",
                            component: () => import("@/views/activity/activityTasks/ActivityTasks.vue"),
                            meta: {
                                title: "活动任务",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/tasks",
                                id: 2
                            }
                        },
                        {
                            path: "/activity/materials",
                            component: () => import("@/views/activity/activityMaterials/ActivityMaterials.vue"),
                            meta: {
                                title: "课程评价",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/materials",
                                id: 3
                            }
                        },
                        {
                            path: "/activity/materialsDetails",
                            component: () => import("@/views/activity/activityMaterials/ActivityMaterialsDetails.vue"),
                            meta: {
                                title: "评价详情",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/materialsDetails",
                                id: 3
                            }
                        },
                        {
                            path: "/activity/videos",
                            component: () => import("@/views/activity/activityVideos/ActivityVideos.vue"),
                            meta: {
                                title: "活动视频",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/videos",
                                id: 4
                            }
                        },
                        {
                            path: "/activity/schedule",
                            component: () => import("@/views/activity/activitySchedule/ActivitySchedule.vue"),
                            meta: {
                                title: "活动日程",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/schedule",
                                id: 5
                            }
                        },
                        {
                            path: "/activity/hotel",
                            component: () => import("@/views/activity/activityHotel/ActivityHotel.vue"),
                            meta: {
                                title: "酒店预定",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                fatherRoute2: "/activity/hotel",
                                id: 6
                            }
                        }
                    ],
                    meta: {
                        title: "活动管理",
                        keepAlive: true,
                        fatherRoute: "/activity",
                        id: 1
                    }
                },
                {
                    path: "/member",
                    component: () => import("@/views/member/Main.vue"),
                    redirect: "/member/management",
                    children: [
                        {
                            path: "/member/management",
                            component: () => import("@/views/member/memberManagement/memberManagement.vue"),
                            meta: {
                                title: "会员管理",
                                keepAlive: true,
                                fatherRoute: "/member",
                                fatherRoute2: "/member/management",
                                id: 1
                            }
                        },
                        {
                            path: "/member/addManagement",
                            component: () => import("@/views/member/memberManagement/AddManagement.vue"),
                            meta: {
                                title: "新增会员",
                                keepAlive: true,
                                fatherRoute: "/member",
                                fatherRoute2: "/member/management",
                                id: 1
                            }
                        },
                        {
                            path: "/member/committeeMembers",
                            component: () => import("@/views/member/committeeMembers/committeeMembers.vue"),
                            meta: {
                                title: "专委会成员",
                                keepAlive: true,
                                fatherRoute: "/member",
                                fatherRoute2: "/member/committeeMembers",
                                id: 1
                            }
                        },
                        {
                            path: "/member/AddcommitteeMembers",
                            component: () => import("@/views/member/committeeMembers/AddcommitteeMembers.vue"),
                            meta: {
                                title: "新增会员",
                                keepAlive: true,
                                fatherRoute: "/member",
                                fatherRoute2: "/member/committeeMembers",
                                id: 1
                            }
                        },
                        {
                            path: "/member/membership",
                            component: () => import("@/views/member/membership/Membership.vue"),
                            meta: {
                                title: "会员身份",
                                keepAlive: true,
                                fatherRoute: "/member",
                                fatherRoute2: "/member/membership",
                                id: 1
                            }
                        },
                    ],
                    meta: {
                        title: "会员管理",
                        keepAlive: true,
                        fatherRoute: "/member",
                        id: 1
                    }
                },
                {
                    path: "/system",
                    component: () => import("@/views/system/Main.vue"),
                    redirect: "/system/carousel",
                    children: [
                        {
                            path: "/system/carousel",
                            component: () => import("@/views/system/carousel/Carousel.vue"),
                            meta: {
                                title: "轮播设置",
                                keepAlive: true,
                                fatherRoute: "/system",
                                fatherRoute2: "/system/carousel",
                                id: 1
                            }
                        },
                        {
                            path: "/system/addCarousel",
                            component: () => import("@/views/system/carousel/AddCarousel.vue"),
                            meta: {
                                title: "新增轮播",
                                keepAlive: true,
                                fatherRoute: "/system",
                                fatherRoute2: "/system/carousel",
                                id: 1
                            }
                        },
                        {
                            path: "/system/roleAuthorization",
                            component: () => import("@/views/system/roleAuthorization/RoleAuthorization.vue"),
                            meta: {
                                title: "角色管理",
                                keepAlive: true,
                                fatherRoute: "/system",
                                fatherRoute2: "/system/roleAuthorization",
                                id: 1
                            }
                        },
                        {
                            path: "/system/employeeAccount",
                            component: () => import("@/views/system/employeeAccount/EmployeeAccount.vue"),
                            meta: {
                                title: "工作人员",
                                keepAlive: true,
                                fatherRoute: "/system",
                                fatherRoute2: "/system/employeeAccount",
                                id: 1
                            }
                        },
                        {
                            path: "/system/addAccount",
                            component: () => import("@/views/system/employeeAccount/AddAccount.vue"),
                            meta: {
                                title: "新增工作人员",
                                keepAlive: true,
                                fatherRoute: "/system",
                                fatherRoute2: "/system/employeeAccount",
                                id: 1
                            }
                        },
                        {
                            path: "/system/dataDictionary",
                            component: () => import("@/views/system/dataDictionary/DataDictionary.vue"),
                            meta: {
                                title: "数据字典",
                                keepAlive: true,
                                fatherRoute: "/system",
                                fatherRoute2: "/system/dataDictionary",
                                id: 1
                            }
                        },
                    ],
                    meta: {
                        title: "系统设置",
                        keepAlive: true,
                        fatherRoute: "/system",
                        id: 1
                    }
                },
                {
                    path: "/procurement",
                    component: () => import("@/views/procurement/Main.vue"),
                    redirect: "/procurement/procurementManagement",
                    children: [
                        {
                            path: "/procurement/procurementManagement",
                            component: () => import("@/views/procurement/procurementManagement/procurementManagement.vue"),
                            meta: {
                                title: "集采管理",
                                keepAlive: true,
                                fatherRoute: "/procurement",
                                fatherRoute2: "/procurement/procurementManagement",
                                id: 1
                            }
                        },
                        {
                            path: "/procurement/addProcurement",
                            component: () => import("@/views/procurement/procurementManagement/addProcurement.vue"),
                            meta: {
                                title: "新增集采",
                                keepAlive: true,
                                fatherRoute: "/procurement",
                                fatherRoute2: "/procurement/procurementManagement",
                                id: 1
                            }
                        },
                        {
                            path: "/procurement/procurementList",
                            component: () => import("@/views/procurement/procurementManagement/procurementList.vue"),
                            meta: {
                                title: "集采报名列表",
                                keepAlive: true,
                                fatherRoute: "/procurement",
                                fatherRoute2: "/procurement/procurementManagement",
                                id: 1
                            }
                        },
                        {
                            path: "/procurement/BackupMenu",
                            component: () => import("@/views/procurement/BackupMenu/BackupMenu.vue"),
                            meta: {
                                title: "备用菜单",
                                keepAlive: true,
                                fatherRoute: "/procurement",
                                fatherRoute2: "/procurement/BackupMenu",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "集采管理",
                        keepAlive: true,
                        fatherRoute: "/procurement",
                        id: 1
                    }
                },
                {
                    path: "/financial",
                    component: () => import("@/views/financial/Main.vue"),
                    redirect: "/financial/financialManagement",
                    children: [
                        {
                            path: "/financial/financialManagement",
                            component: () => import("@/views/financial/financialManagement/financialManagement.vue"),
                            meta: {
                                title: "财务明细",
                                keepAlive: true,
                                fatherRoute: "/financial",
                                fatherRoute2: "/financial/financialManagement",
                                id: 1
                            }
                        },
                        {
                            path: "/financial/BackupMenu",
                            component: () => import("@/views/financial/BackupMenu/BackupMenu.vue"),
                            meta: {
                                title: "备用菜单",
                                keepAlive: true,
                                fatherRoute: "/financial",
                                fatherRoute2: "/financial/BackupMenu",
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "集采管理",
                        keepAlive: true,
                        fatherRoute: "/financial",
                        id: 1
                    }
                },
            ]
        },
        {
            path: "/login",
            component: () => import("@/views/login/Login.vue"),
            meta: {
                title: "登录"
            }
        },
        {
            path: "/forgotPassword",
            component: () => import("@/views/login/ForgotPassword.vue"),
            meta: {
                title: "忘记密码"
            }
        },
        {
            path: "/importPersonnel",
            component: () => import("@/views/backupMenu/importPersonnel.vue"),
            meta: {
                title: "上传工作人员"
            }
        },
        //登录
        {
            path: "/indexpdf",
            name: "indexpdf",
            component: () => import('@/views/Index.vue')
        },
    ]
})
export default router
